// search_modal.js
(function () {
  'use strict';

  let retryCount = 0;
  const MAX_RETRIES = 50; // 5秒間リトライ（100ms × 50回）

  // jQueryが読み込まれるまで待機
  function initSearchModal() {
    if (typeof jQuery === 'undefined') {
      retryCount++;
      if (retryCount < MAX_RETRIES) {
        setTimeout(initSearchModal, 100);
      } else {
        console.error(
          'jQuery could not be loaded after 5 seconds'
        );
      }
      return;
    }

    const $ = jQuery;

    const $modal = $('#searchModal');
    const $overlay = $modal.find(
      '.modal__overlay'
    );
    const $dialog = $modal.find('.modal__dialog');

    const $viewCategories = $modal.find(
      '[data-view="categories"]'
    );
    const $viewMenu = $modal.find(
      '[data-view="menu"]'
    );
    const $subtitleCat = $modal.find(
      '[data-view-title="categories"]'
    );
    const $subtitleMenu = $modal.find(
      '[data-view-title="menu"]'
    );
    const $currentLabel = $modal.find(
      '[data-current-category-label]'
    ); // SP判定
    const isSPModal = () =>
      window.innerWidth <= 1023.5;

    // 初期状態（CSSアニメなし前提）
    $modal.hide();
    $overlay.css({ opacity: 0 });
    $dialog.css({
      opacity: 0,
      transform: isSPModal()
        ? 'translateX(-50%) translateY(20px)'
        : 'translate(-50%, -52%) scale(0.98)'
    });

    const DUR = 300; // ミリ秒
    const EASE = 'swing'; // スクロールロック（iOS対応）
    let scrollY = 0;
    const isIOS = /iP(hone|od|ad)/.test(
      navigator.userAgent
    );
    // macOS Safari も含めたSafari判定
    const isSafari =
      isIOS ||
      (/Version\/[\d.]+.*Safari/.test(
        navigator.userAgent
      ) &&
        !/Chrome|Chromium|Android/.test(
          navigator.userAgent
        ));

    // スクロールイベントをキャンセルする関数
    function preventScroll(e) {
      e.preventDefault();
    }
    function lockScroll() {
      if (isSafari) {
        scrollY =
          window.scrollY || window.pageYOffset;
        document.body.style.top = `-${scrollY}px`;
        document.body.classList.add(
          'scroll-lock-ios'
        );
        // iOSはtouchmoveも止める
        document.addEventListener(
          'touchmove',
          preventScroll,
          { passive: false }
        );
      } else {
        document.body.classList.add(
          'scroll-lock'
        );
        // wheelとkeydownによるスクロールを防ぐ
        document.addEventListener(
          'wheel',
          preventScroll,
          { passive: false }
        );
      }
    }
    function unlockScroll() {
      if (isSafari) {
        document.body.classList.remove(
          'scroll-lock-ios'
        );
        document.body.style.top = '';
        // iOSでスムーススクロールが走らないよう瞬時に戻す
        document.documentElement.style.scrollBehavior =
          'auto';
        document.body.style.scrollBehavior =
          'auto';
        window.scrollTo({
          top: scrollY,
          left: 0,
          behavior: 'instant'
        });
        // 少し遅延させてからscroll-behaviorを元に戻す
        setTimeout(function () {
          document.documentElement.style.scrollBehavior =
            '';
          document.body.style.scrollBehavior = '';
        }, 0);
        document.removeEventListener(
          'touchmove',
          preventScroll
        );
      } else {
        document.body.classList.remove(
          'scroll-lock'
        );
        document.removeEventListener(
          'wheel',
          preventScroll
        );
      }
    }

    function openModal() {
      // 表示開始
      $modal
        .show()
        .attr('aria-hidden', 'false')
        .css({ pointerEvents: 'none' });

      // アニメ：オーバーレイ
      $overlay
        .stop(true, true)
        .animate({ opacity: 1 }, DUR, EASE); // アニメ：ダイアログ（opacity＋transform補間）
      $dialog.stop(true, true).animate(
        { opacity: 1 },
        {
          duration: DUR,
          easing: EASE,
          step: function (now) {
            const p = now; // 0→1
            if (isSPModal()) {
              const ty = 20 - 20 * p; // 20px → 0px
              $dialog.css(
                'transform',
                `translateX(-50%) translateY(${ty}px)`
              );
            } else {
              const ty = -52 + 2 * p; // -52% → -50%
              const sc = 0.98 + 0.02 * p; // 0.98 → 1
              $dialog.css(
                'transform',
                `translate(-50%, ${ty}%) scale(${sc})`
              );
            }
          },
          complete: function () {
            $modal.css({ pointerEvents: 'auto' });
          }
        }
      );

      lockScroll();
      showCategories();

      const $firstCat = $modal
        .find('.category-card')
        .first();
      if ($firstCat.length)
        $firstCat.trigger('focus');

      // ESCで閉じる
      $(document).on(
        'keydown.modal',
        function (e) {
          if (e.key === 'Escape') closeModal();
        }
      );
    }
    function closeModal() {
      // aria-hidden を設定する前にフォーカスをモーダル外へ移動する
      // （フォーカスを持ったままの子孫要素に aria-hidden をかけると警告が出るため）
      $('#search_bnr').trigger('focus');

      $modal
        .attr('aria-hidden', 'true')
        .css({ pointerEvents: 'none' });

      // アニメ：オーバーレイ
      $overlay
        .stop(true, true)
        .animate({ opacity: 0 }, DUR, EASE);

      // アニメ：ダイアログ（逆方向）
      $dialog.stop(true, true).animate(
        { opacity: 0 },
        {
          duration: DUR,
          easing: EASE,
          step: function (now) {
            const p = 1 - now; // 0→1（閉じるにつれて増加）
            if (isSPModal()) {
              const ty = 20 * p; // 0px → 20px
              $dialog.css(
                'transform',
                `translateX(-50%) translateY(${ty}px)`
              );
            } else {
              const ty = -50 - 2 * p; // -50% → -52%
              const sc = 1 - 0.02 * p; // 1 → 0.98
              $dialog.css(
                'transform',
                `translate(-50%, ${ty}%) scale(${sc})`
              );
            }
          },
          complete: function () {
            $modal
              .hide()
              .css({ pointerEvents: 'auto' });
            // 初期値へ戻しておく（次回のため）
            $dialog.css({
              opacity: 0,
              transform: isSPModal()
                ? 'translateX(-50%) translateY(20px)'
                : 'translate(-50%, -52%) scale(0.98)'
            });
          }
        }
      );

      unlockScroll();
      $(document).off('keydown.modal');
    }

    // ビュー切替
    function showCategories() {
      $subtitleMenu.addClass('is-hidden');
      $subtitleCat.removeClass('is-hidden');
      $viewMenu.addClass('is-hidden');
      $viewCategories.removeClass('is-hidden');
      $viewMenu
        .find('.menu-list')
        .attr('hidden', true);
      $currentLabel.text('');
    }

    function showMenu(category, labelText) {
      $subtitleCat.addClass('is-hidden');
      $subtitleMenu.removeClass('is-hidden');
      $viewCategories.addClass('is-hidden');
      $viewMenu.removeClass('is-hidden');
      $viewMenu
        .find('.menu-list')
        .attr('hidden', true);
      $viewMenu
        .find(
          `.menu-list[data-menu-for="${category}"]`
        )
        .attr('hidden', false);
      $currentLabel.text(labelText || '');
    }

    // イベント
    $('#search_bnr').on('click', openModal);
    $modal.on(
      'click',
      '[data-close="button"], [data-close="overlay"]',
      closeModal
    );
    $modal.on(
      'click',
      '.category-card',
      function () {
        const category = $(this).data('category');
        const labelText = $(this)
          .find('.category-card__title')
          .text();
        showMenu(category, labelText);
      }
    );
    $modal.on(
      'click',
      '.back-button',
      function () {
        showCategories();
      }
    );
  }

  // DOMContentLoaded後に初期化
  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initSearchModal
    );
  } else {
    initSearchModal();
  }
})();
